<template>
  <v-container>
    <h3 class="page-title">一階報到作業</h3>
    <v-row>
      <v-col cols="6" sm="3">
        <v-autocomplete
          v-model="selected.行政區"
          outlined
          :items="衛生所"
          label="負責衛生所"
          dense
          hide-details
          :disabled="!!this.$store.state.user.行政區"
        ></v-autocomplete>
      </v-col>
      <v-col cols="6" sm="3">
        <v-autocomplete
          v-model.number="selected.年度"
          :items="年度"
          label="年度"
          outlined
          dense
          hide-details
        ></v-autocomplete>
      </v-col>
      <v-col cols="6" sm="3">
        <v-autocomplete
          v-model="selected.場次"
          :items="uniqSections"
          label="場次"
          no-data-text="請輸入關鍵字"
          outlined
          dense
          hide-details
          @update:search-input="searchSection"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="6" sm="3">
        <v-select
          v-model="selected.篩選條件"
          :items="[
            '全部',
            '成人健康檢查',
            'BC肝檢查',
            '口腔篩檢',
            '子宮頸抹片檢查',
            '乳房X光攝影檢查',
            '糞便潛血檢查',
            '未填線上問卷',
            '未填滿意問卷',
            '已報到',
            '已完成',
          ]"
          label="篩選條件"
          outlined
          dense
          hide-details
        ></v-select>
      </v-col>
      <v-col cols="6" sm="3">
        <v-text-field
          v-model="selected.關鍵字"
          label="關鍵字"
          outlined
          dense
          hide-details
          @keyup.enter="scanHandler(selected.關鍵字)"
        >
          <template v-slot:append>
            <v-icon class="mr-1" @click="selected.關鍵字 = null">
              mdi-close
            </v-icon>
            <v-icon class="mr-1" @click="load"> mdi-magnify </v-icon>
            <v-icon @click="scanHandler(selected.關鍵字)">
              mdi-barcode-scan
            </v-icon>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="6" sm="3" v-if="isAdmin">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateRangeText"
              label="日期區間"
              readonly
              v-bind="attrs"
              v-on="on"
              outlined
              dense
              hide-details
              clearable
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dateRange"
            range
            no-title
            @input="checkClose"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="5" sm="5">
        <v-btn color="warning mr-4" v-if="!isHospital" @click="showQRCode"
          >場次 QR</v-btn
        >

        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mr-4" color="info" v-bind="attrs" v-on="on">
              下載資料
            </v-btn>
          </template>
          <v-list>
            <v-list-item link>
              <v-list-item-title @click="exportList">
                場次預約列表
              </v-list-item-title>
            </v-list-item>
            <v-list-item link v-if="!isHospital">
              <v-list-item-title @click="exportStation">
                數位站點數據
              </v-list-item-title>
            </v-list-item>
            <!-- <v-list-item link>
              <v-list-item-title @click="exportSurvey">
                外部問卷內容
              </v-list-item-title>
            </v-list-item> -->
            <v-list-item link>
              <v-list-item-title @click="exportPrint">
                列印民眾表單
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn color="secondary mr-4" v-if="isManager" @click="showPush"
          >推播</v-btn
        >
        <v-btn color="primary" @click="loadList">重新讀取</v-btn>
        <!-- <v-btn color="primary" @click="scanHandler('R220672572')">test</v-btn> -->
      </v-col>
      <v-col
        cols="12"
        sm="6"
        class="ml-auto text-right mt-1 text-body-1 font-weight-bold"
      >
        <div class="d-inline mr-4">已預約：{{ list.length }}</div>
        <div class="d-inline mr-4">
          已報到：{{ list.filter((v) => v.已報到).length }}
        </div>
        <div class="d-inline mr-4">
          已完成：{{ list.filter((v) => !!v.完成時間).length }}
        </div>
        <div class="d-inline">現掛：{{ list.filter((v) => v.現掛).length }}</div>
      </v-col>
    </v-row>
    <div class="mt-4">
      <v-data-table
        :headers="headers"
        :items="filterList"
        no-data-text="尚無預約"
        :mobile-breakpoint="0"
        :footer-props="{
          itemsPerPageText: '每頁幾筆',
          itemsPerPageOptions: [10, 30, -1],
        }"
      >
        <template v-slot:item.序號="{ index }"> {{ index + 1 }} </template>
        <template v-slot:item.篩檢項目="{ item }">
          {{ Object.keys(lodash.pickBy(item.篩檢項目, (o) => o)).join("、") }}
          <v-icon
            class="ml-2 pointer"
            small
            @click="openReturnDialog(item.身分證字號, item._id)"
            >mdi-pencil</v-icon
          >
        </template>
        <template v-slot:item.report="{ item }">
          <div v-if="!item.report[0] || !item.report[0].外部問卷">
            <a :href="surveyLink(item)" target="_blank" rel="noopener">未填</a>
          </div>
        </template>
        <template v-slot:item.滿意問卷="{ item }">
          <div v-if="!item.report[0] || !item.report[0].滿意問卷">
            <a :href="surveySatisfactionLink(item)" target="_blank" rel="noopener">未填</a>
          </div>
        </template>
        <template v-slot:item.列印="{ item }">
          <v-icon
            class="pointer"
            @click="singlePrint(item)"
            v-if="item.報到號碼"
          >
            mdi-printer
          </v-icon>
        </template>
        <template v-slot:item.報到號碼="{ item }">
          {{ item.報到號碼 || "-" }}
        </template>
        <template v-slot:item.年齡="{ item }">
          {{ theAge(item.出生年月日) }}
        </template>
        <!-- <template v-slot:item.站點="{ item }">
          <div v-if="Object.keys(item.站點 || {}).length == 站點.length">
            完成
          </div>
          <div v-else>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">未完成</span>
              </template>
              <span>{{
                lodash
                  .pullAll([...站點], Object.keys(item.站點 || {}))
                  .join("、")
              }}</span>
            </v-tooltip>
          </div>
        </template> -->
        <template v-slot:item.已報到="{ item }">
          <v-simple-checkbox
            @input="toggleCheckin(item)"
            :off-icon="
              item.已報到 === null
                ? 'mdi-crop-free'
                : 'mdi-checkbox-blank-outline'
            "
            v-model="item.已報到"
            :ripple="false"
          ></v-simple-checkbox>
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="QRDialog" width="auto">
      <v-card class="text-center pa-5">
        <template v-if="selected.場次">
          <qrcode-vue
            class="mb-4"
            :value="stationURL"
            size="200"
            level="Q"
          ></qrcode-vue>
          <!-- {{ stationURL }} -->
          <div>日期：{{ selected.場次.日期 }}</div>
          <div>地點：{{ selected.場次.地點 }}</div>
        </template>
      </v-card>
    </v-dialog>
    <v-dialog v-model="applyDialog" width="auto">
      <v-card class="text-center pa-5">
        <v-alert dense text type="error">
          民眾無法現場掛號，請確認是否為市民或今年是否可執行篩檢。若為不在籍民眾，請民眾掃描
          QR code 進行資料登錄後再次報到。
        </v-alert>
        <template v-if="selected.場次">
          <a :href="applyURL" target="_blank" rel="noopener">
            <qrcode-vue
              class="mb-4"
              :value="applyURL"
              size="200"
              level="Q"
            ></qrcode-vue>
          </a>
          <!-- {{ stationURL }} -->
          <div>日期：{{ selected.場次.日期 }}</div>
          <div>地點：{{ selected.場次.地點 }}</div>
        </template>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="printDialog"
      v-if="printDialog && isSelectedSection()"
      width="auto"
    >
      <v-card class="text-center pa-5">
        <PrintDialog
          :list="list"
          :selectedSection="selected.場次"
          :singlePrintID="singlePrintID"
          @loadList="loadList"
          @close="printDialog = false"
        ></PrintDialog>
      </v-card>
    </v-dialog>
    <v-dialog v-model="returnDialog" v-if="returnDialog" width="300px">
      <ReturnDialog
        :id="returnID"
        :reservationId="reservationId"
        @close="returnDialog = false"
        @loadList="loadList"
      ></ReturnDialog>
    </v-dialog>
    <v-dialog v-model="walkinDialog" v-if="walkinDialog" width="300px">
      <WalkinDialog
        :walkin="walkin"
        :section="selected.場次"
        @close="walkinDialog = false"
        @loadList="loadList"
        @singlePrint="singlePrint"
      ></WalkinDialog>
    </v-dialog>
    <PushDialog
      v-if="pushDialog"
      v-model="pushDialog"
      :theList="list"
    ></PushDialog>
  </v-container>
</template>

<script>
import barcodeReader from "@wrurik/barcode-scanner";
import downloadCsv from "download-csv";
import QrcodeVue from "qrcode.vue";
import { 行政區, 站點, 站點項目 } from "@/libs/const";
import dayjs from "dayjs";
import _ from "lodash";
import { surveyURL, surveySatisfactionURL } from "@/../env.js";
import PrintDialog from "@/components/Print/dialog_t1";
import ReturnDialog from "@/components/Checkin/returnDialog";
import WalkinDialog from "@/components/Checkin/walkinDialog";
import PushDialog from "@/components/Checkin/pushDialog";
import util from "@/mixins/util";

const all行政區 = {
  text: "全部",
  value: null,
};
const 年度 = dayjs().get("year") - 1911;
export default {
  name: "Checkin",
  components: {
    QrcodeVue,
    PrintDialog,
    ReturnDialog,
    WalkinDialog,
    PushDialog,
  },
  mixins: [util],
  data: () => ({
    sectionFilter: null,
    cancelScan: null,
    sections: [],
    list: [],
    QRDialog: false,
    applyDialog: false,
    printDialog: false,
    returnDialog: false,
    pushDialog: false,
    selected: {
      行政區: all行政區,
      年度,
      場次: null,
      篩選條件: "全部",
      關鍵字: "",
    },
    站點: Object.keys(站點),
    lodash: _,
    returnID: null,
    singlePrintID: null,
    walkinDialog: false,
    walkin: {},
    dateRange: [],
    menu: false,
  }),
  computed: {
    dateRangeText: {
      get() {
        return this.dateRange.join(" ~ ");
      },
      set() {
        this.dateRange = [];
      },
    },
    headers() {
      return [
        { text: "序號", value: "序號" },
        { text: "報到號碼", value: "報到號碼" },
        { text: "建議時間", value: "建議時間" },
        { text: "姓名", value: "姓名" },
        { text: "身分證字號", value: "身分證字號" },
        { text: "出生年月日", value: "出生年月日" },
        { text: "年齡", value: "年齡" },
        { text: "電話", value: "電話", sortable: false },
        { text: "篩檢項目", value: "篩檢項目", sortable: false },
        // { text: "站點狀態", value: "站點", sortable: false },
        {
          text: "線上問卷",
          value: "report",
          sortable: false,
          align: this.isHospital ? " d-none" : "",
        },
        {
          text: "滿意問卷",
          value: "滿意問卷",
          sortable: false,
          align: this.isHospital || !surveySatisfactionURL ? " d-none" : "",
        },
        { text: "列印", value: "列印" },
        { text: "已報到", value: "已報到" },
        { text: "報到時間", value: "報到時間", width: "170px" },
        { text: "完成時間", value: "完成時間", width: "170px" },
      ];
    },
    stationURL() {
      let section = _.find(this.sections, this.selected.場次);
      let url = `${window.location.origin}/station/${section?._id}`;
      return url;
    },
    applyURL() {
      let section = _.find(this.sections, this.selected.場次);
      let url = `${window.location.origin}/apply/${section?._id}`;
      return url;
    },
    filterList() {
      let list = [...this.list];
      if (this.selected.關鍵字) {
        list = list.filter((person) => {
          const keyword = this.selected.關鍵字;
          return (
            person.姓名?.includes(keyword) ||
            person.身分證字號?.includes(keyword) ||
            person.出生年月日?.toString().includes(keyword) ||
            person.電話?.includes(keyword)
          );
        });
      }
      switch (this.selected.篩選條件) {
        case "已報到":
          list = list.filter((person) => person.已報到);
          break;
        case "已完成":
          list = list.filter((person) => !!person.完成時間);
          break;
        case "成人健康檢查":
          list = list.filter((person) => person.篩檢項目.成健);
          break;
        case "BC肝檢查":
          list = list.filter((person) => person.篩檢項目.BC肝);
          break;
        case "口腔篩檢":
          list = list.filter((person) => person.篩檢項目.口腔);
          break;
        case "子宮頸抹片檢查":
          list = list.filter((person) => person.篩檢項目.子抹);
          break;
        case "乳房X光攝影檢查":
          list = list.filter((person) => person.篩檢項目.乳攝);
          break;
        case "糞便潛血檢查":
          list = list.filter((person) => person.篩檢項目.大腸);
          break;
        case "未填線上問卷":
          list = list.filter((person) => !person.report[0].外部問卷);
          break;
        case "未填滿意問卷":
          list = list.filter((person) => !person.report[0].滿意問卷);
          break;
      }
      return list;
    },
    衛生所() {
      let place = 行政區.map((v) => ({
        text: v + "衛生所",
        value: v,
      }));
      place.unshift(all行政區);
      return place;
    },
    年度() {
      let years = [年度 + 1];
      for (let n = 0; n <= 3; n++) {
        years.push(年度 - n);
      }
      return years;
    },
    uniqSections() {
      if (!this.sectionFilter || this.sectionFilter.length < 2) {
        return [];
      }
      let sections = this.sections.map((row) => ({
        text: `${dayjs(row.日期).format("MM/DD")} ${row.地點}`,
        value: {
          日期: row.日期,
          地點: row.地點,
        },
      }));
      sections = sections.filter((row) =>
        row.text.includes(this.sectionFilter)
      );
      sections = _.uniqWith(sections, _.isEqual);
      sections = _.sortBy(sections, ["text"]);

      return sections;
    },
  },
  async created() {
    if (this.$store.state.user.行政區) {
      this.selected.行政區 = this.衛生所.find(
        (row) => row.value == this.$store.state.user.行政區
      );
    }
    await this.load();
    this.cancelScan = barcodeReader.onScan(this.scanHandler, {
      endCharacterCode: 0,
      scanDuration: 300,
    });
  },
  beforeDestroy() {
    this.cancelScan();
  },

  methods: {
    searchSection(search) {
      this.sectionFilter = search;
    },
    checkClose() {
      if (this.dateRange.length == 2) {
        this.menu = false;
      }
    },
    singlePrint(item) {
      this.printDialog = true;
      this.singlePrintID = item.報到號碼;
    },
    openReturnDialog(id, reservationId) {
      this.returnID = id;
      this.reservationId = reservationId;
      this.returnDialog = true;
    },
    theAge(date) {
      let birth = parseInt(date) + 19110000 + "";
      let year = dayjs(birth).get("year");
      let thisYear = dayjs().get("year");
      return thisYear - year;
    },
    isSelectedSection() {
      if (!this.selected.場次 && this.dateRange.length == 0) {
        this.$toast.error("尚未選擇場次");
        return false;
      }
      return true;
    },
    showQRCode() {
      if (!this.isSelectedSection()) {
        return false;
      }
      this.QRDialog = true;
    },
    showApplyDialog() {
      if (!this.isSelectedSection()) {
        return false;
      }
      this.applyDialog = true;
    },
    showPush() {
      if (!this.isSelectedSection()) {
        return false;
      }
      this.pushDialog = true;
    },
    exportPrint() {
      if (!this.isSelectedSection()) {
        return false;
      }
      this.singlePrintID = null;
      this.printDialog = true;
    },
    exportStation() {
      if (!this.isSelectedSection()) {
        return false;
      }
      let data = [...this.filterList];
      data = data.map((row) => {
        return {
          日期: row.日期,
          地點: row.地點,
          身分證字號: row.身分證字號,
          姓名: row.姓名,
          ..._.pick(row.report[0], 站點項目),
        };
      });
      let fileName = this.dateRange.length
        ? `${this.dateRange[0]}~${this.dateRange[1]}`
        : `${this.selected.場次?.日期} ${this.selected.場次?.地點}`;
      downloadCsv(data, {}, `${fileName}數位站點數據`);
    },
    exportList() {
      if (!this.isSelectedSection()) {
        return false;
      }
      let data = [...this.filterList];
      data = data.map((row) => {
        let {
          日期,
          地點,
          建議時間,
          報到號碼,
          現掛,
          姓名,
          身分證字號,
          出生年月日,
          電話,
          篩檢項目,
          report,
          已報到,
          報到時間,
          完成時間,
        } = row;
        return {
          日期,
          地點,
          建議時間,
          報到號碼,
          現掛: 現掛 ? "是" : "否",
          姓名,
          身分證字號,
          出生年月日,
          電話,
          篩檢項目: Object.keys(_.pickBy(篩檢項目, (o) => o)).join("、"),
          線上問卷: report[0].外部問卷 ? "" : "未填",
          已報到: 已報到 ? "是" : "否",
          報到時間,
          完成時間,
        };
      });
      let fileName = this.dateRange.length
        ? `${this.dateRange[0]}~${this.dateRange[1]}`
        : `${this.selected.場次?.日期} ${this.selected.場次?.地點}`;
      downloadCsv(data, {}, `${fileName}預約篩檢列表`);
    },
    surveyLink(person) {
      return `${surveyURL}?aka_name=${person.姓名}&aka_id=${person.身分證字號}`;
    },
    surveySatisfactionLink(person) {
      return `${surveySatisfactionURL}?aka_id=${person.身分證字號}`;
    },
    // exportSurvey() {
    //   if (!this.isSelectedSection()) {
    //     return false;
    //   }
    //   let data = [...this.list];

    //   data = data
    //     .filter((row) => row.report[0].外部問卷)
    //     .map((row) => {
    //       let {
    //         報到號碼,
    //         姓名,
    //         身分證字號,
    //         出生年月日,
    //         電話,
    //         地址,
    //         性別,
    //         年齡,
    //         問卷,
    //         report,
    //       } = row;
    //       report[0].外部問卷[`F1 身體質量指數(BMI)`] =
    //         report[0].外部問卷[
    //           "F1 身體質量指數(BMI) (公斤/米2, kg/m2)身高單位換算成公尺，體重單位為公斤\r計算方式：公斤÷公尺÷公尺\r例：160公分，50公斤，取至小數點後一位，以下四捨五入\rBMI為「50公斤÷1.6公尺÷1.6公尺=19.5」\r"
    //         ] ||
    //         report[0].外部問卷[
    //           "F1 身體質量指數(BMI) (公斤/米2, kg/m2)身高單位換算成公尺，體重單位為公斤\r計算方式：公斤÷公尺÷公尺\r例：160公分，50公斤，取至小數點後一位，以下四捨五入\rBMI為「50公斤÷1.6公尺÷1.6公尺=19.5」"
    //         ];
    //       delete report[0].外部問卷[
    //         "F1 身體質量指數(BMI) (公斤/米2, kg/m2)身高單位換算成公尺，體重單位為公斤\r計算方式：公斤÷公尺÷公尺\r例：160公分，50公斤，取至小數點後一位，以下四捨五入\rBMI為「50公斤÷1.6公尺÷1.6公尺=19.5」\r"
    //       ];
    //       delete report[0].外部問卷[
    //         "F1 身體質量指數(BMI) (公斤/米2, kg/m2)身高單位換算成公尺，體重單位為公斤\r計算方式：公斤÷公尺÷公尺\r例：160公分，50公斤，取至小數點後一位，以下四捨五入\rBMI為「50公斤÷1.6公尺÷1.6公尺=19.5」"
    //       ];

    //       return {
    //         報到號碼,
    //         姓名,
    //         身分證字號,
    //         出生年月日,
    //         電話,
    //         地址,
    //         性別,
    //         年齡,
    //         ..._.mapValues(問卷, (o) =>
    //           typeof o == "string" ? o.replace(/,/g, "，") : ""
    //         ),
    //         ..._.mapValues(report[0].外部問卷, (o) =>
    //           typeof o == "string" ? o.replace(/,/g, "，") : ""
    //         ),
    //       };
    //     });

    //   let header = data.reduce(
    //     (header, row) => {
    //       return _.union(header, Object.keys(row));
    //     },
    //     ["姓名", "身分證字號", "出生年月日", "電話", "地址", "性別", "年齡"]
    //   );

    //   downloadCsv(
    //     data,
    //     header,
    //     `${this.selected.場次.日期} ${this.selected.場次.地點}預約篩檢問卷`
    //   );
    // },

    scanHandler(value, e) {
      if (!value) return;
      if (
        // document.activeElement.id != "keyword" &&
        /^[A-Z](1|2)\d{8}$/i.test(value)
      ) {
        this.selected.關鍵字 = value;
        let finded = this.list.find((o) => o.身分證字號 == value);

        if (finded) {
          if (!finded.已報到) {
            finded.已報到 = true;
            this.toggleCheckin(finded);
            this.$toast.success(
              `${finded.身分證字號}(${finded.姓名}) 報到完成`
            );
          } else {
            this.$toast.error(
              `${finded.身分證字號}(${finded.姓名}) 已報到完畢`
            );
          }
        } else {
          this.queryVaccine(value);
          // this.$toast.error(`本場次找不到此民眾！`);
          this.checkWalkin(value);
        }
      }
    },
    async checkWalkin(id) {
      if (!this.selected.場次) {
        return false;
      }

      let { person, items } = (
        await this.axios.get(`/dashboard/walkinCheck/${id}`)
      ).data;

      // let section = _.find(this.sections, this.selected.場次);
      // _.forEach(section.篩檢項目, (value, key) => {
      //   if (!value) {
      //     items = items.filter((item) => item !== key);
      //   }
      // });

      if (!person.出生年月日) {
        if (items.length) {
          this.$toast.error(
            `民眾不在戶籍名冊，但可執行${items.join(
              "、"
            )}請引導民眾填寫註冊表單！`
          );
        } else {
          this.$toast.error(
            `民眾不在戶籍名冊，無可執行篩檢項目，可引導民眾填寫註冊表單！`
          );
        }

        this.showApplyDialog();
      } else if (!items.length) {
        this.$toast.success(`民眾無可執行篩檢項目！`);
      } else {
        this.walkin = {
          person,
          items,
        };
        this.walkinDialog = true;
      }
    },
    async queryVaccine(id) {
      if (this.$city.name != "臺南市") {
        return;
      }
      let records = (
        await this.axios.get(`https://influenza.tncghb.gov.tw/api/niis/${id}`, {
          alone: true,
        })
      ).data;
      if (records.length) {
        // let sortRecords = _.sortBy(records, ["接種日期"]);
        // sortRecords.reverse();
        let sortRecords = _.filter(sortRecords, (record) => {
          return record.疫苗劑別.includes("JN");
        });

        // let record = sortRecords[0];
        // let date = parseInt(record.接種日期) + 19110000 + "";
        // let 劑別 = record.疫苗劑別.split("-")[1];
        // let 疫苗 = record.疫苗劑別.split("-")[0];

        if (!sortRecords.length) {
          this.$toast.warning("請鼓勵民眾施打 JN.1 疫苗！");
        }
      }
    },
    async load() {
      if (
        this.selected.行政區 instanceof Object &&
        !this.selected.行政區.value
      ) {
        this.selected.行政區 = null;
      }
      let params = {
        年度: this.selected.年度,
        行政區: this.selected.行政區?.value || this.selected.行政區,
      };
      this.sections = (
        await this.axios.get("/dashboard/section", {
          params,
        })
      ).data;
    },
    async loadList() {
      if (!this.isSelectedSection()) {
        return false;
      }
      let params = this.selected.場次;
      if (this.dateRange.length) {
        params = {
          日期: {
            $gte: this.dateRange[0],
            $lte: this.dateRange[1],
          },
        };
      }
      let list = (
        await this.axios.get(`/dashboard/person/list`, {
          params: { query: JSON.stringify(params) },
        })
      ).data;
      this.list = _.sortBy(list, ["報到號碼"]);
    },
    async toggleCheckin(person) {
      if (person.已報到) {
        this.queryVaccine(person.身分證字號);
      }

      let result;
      try {
        result = (
          await this.axios.post(
            "/dashboard/person/toggleCheckin",
            _.pick(person, [
              "_id",
              "年度",
              "身分證字號",
              "已報到",
              "篩檢項目",
              "日期",
              "地點",
            ])
          )
        ).data;
      } catch (e) {
        if (person.已報到) {
          this.$toast.error(
            "請注意！目前網路連線失敗，報到動作沒有傳送至伺服器！"
          );
        }
      }

      if (Object.prototype.hasOwnProperty.call(result, "報到時間")) {
        person.報到時間 = result.報到時間;
      }
    },
  },
  watch: {
    "selected.行政區"() {
      this.load();
    },
    "selected.年度"() {
      this.load();
    },
    "selected.場次"() {
      this.loadList();
    },
    "selected.關鍵字"() {
      this.scanHandler(this.selected.關鍵字);
    },
  },
};
</script>

<style lang="scss" scoped></style>
